
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EmergencyTimeInput extends Vue {
  @Prop({ default: null }) readonly initialValue!: string | null;

  @Prop({ default: false }) readonly isSet!: boolean;

  menuOpen = false;

  dateValue = '';

  timeValue = '';

  @Watch('initialValue', { immediate: true })
  onInitialValueChange(value: string | null) {
    if (value && value.length >= 12) {
      this.dateValue = `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}`;
      this.timeValue = `${value.slice(8, 10)}:${value.slice(10, 12)}`;
    } else {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.dateValue = `${year}-${month}-${day}`;
      this.timeValue = '00:00';
    }
  }

  get currentValue(): string {
    if (!this.dateValue || !this.timeValue) return '';
    const [year, month, day] = this.dateValue.split('-');
    const [hour, minute] = this.timeValue.split(':');
    return `${year}${month}${day}${hour}${minute}`;
  }

  get displayValue(): string {
    if (!this.dateValue || !this.timeValue) return '';
    return `${this.dateValue} ${this.timeValue}`;
  }

  get canSubmit(): boolean {
    return this.currentValue.length === 12;
  }

  onDateChange(value: string) {
    this.dateValue = value;
  }

  onTimeChange(value: string) {
    this.timeValue = value;
  }
}
